import rolesTranslations from "./roles-zh-CN";
import editionsTranslations from "./editions-zh-CN";

export default {
  // 角色具体翻译
  roleDetails: rolesTranslations,
  // 版本翻译
  editions: editionsTranslations,

  common: {
    yes: "是",
    no: "否",
    ok: "确定",
    cancel: "取消",
    close: "关闭",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    add: "添加",
    remove: "移除",
    clear: "清空",
    loading: "加载中...",
    error: "错误",
    success: "成功",
    confirm: "确认",
    back: "返回",
    next: "下一步",
    help: "帮助",
    day: "白天",
  },

  timer: {
    minutes: "分钟",
    start: "开始",
    pause: "暂停",
    reset: "重置",
  },

  menu: {
    title: "菜单",
    grimoire: "魔典",
    townSquare: "城镇广场",
    nightOrder: "夜间顺序",
    characterReference: "角色手册",
    gameState: "游戏状态",
    edition: "版本",
    roles: "配置角色",
    fabled: "添加传奇角色",
    session: "在线会话",
    settings: "设置",
    about: "关于",
  },

  roles: {
    townsfolk: "村民",
    outsider: "外来者",
    minion: "爪牙",
    demon: "恶魔",
    traveler: "旅行者",
    fabled: "传奇角色",
    bluff: "恶魔伪装",
    firstNight: "首夜",
    otherNight: "其他夜晚",
    ability: "能力",
    setup: "设置",
  },

  player: {
    players: "玩家",
    name: "名字",
    role: "角色",
    dead: "死亡",
    alive: "存活",
    usedAbility: "已使用能力",
    isDead: "已死亡",
    isVoteless: "无投票权",
    pronouns: "代词",
    addPlayer: "添加玩家",
    removePlayer: "移除玩家",
    clearPlayers: "清空所有玩家",
    randomizeSeating: "随机座位",
    swap: "交换",
    move: "移动",
    emptySeatName: "空座位",
    // Player card menu items
    changePronouns: "修改代词",
    rename: "重命名",
    movePlayer: "移动玩家",
    swapSeats: "交换座位",
    emptySeat: "清空座位",
    vacateSeat: "离开座位",
    seatOccupied: "座位已占用",
    privateChat: "私聊",
    // Tooltips
    handUp: "举手",
    handDown: "放下",
    swapSeatsTooltip: "与此玩家交换座位",
    movePlayerTooltip: "将玩家移动到此座位",
    nominatePlayerTooltip: "提名此玩家",
    ghostVote: "幽灵投票",
    // Prompts
    playerPronounsPrompt: "玩家代词",
    playerNamePrompt: "玩家名字",
    // Confirm messages
    confirmEmptySeat: "确定要清空此座位吗？",
    confirmRemovePlayer: "确定要移除此玩家吗？",
  },

  voting: {
    vote: "投票",
    votes: "票数",
    handUp: "举手",
    handDown: "放下",
    nomination: "提名",
    nominate: "提名",
    nominee: "被提名者",
    nominator: "提名者",
    voteHistory: "投票历史",
    votingInProgress: "投票进行中",
    votingSpeed: "投票速度",
    locked: "已锁定",
    exile: "流放",
    execute: "处决",
    majority: "多数票",
    votesToTie: "平局所需票数",
    votesToExecute: "处决所需票数",
    // Vote component
    nominated: "提名了",
    inFavor: "赞成",
    majorityIs: "多数票为",
    timePerPlayer: "每位玩家时间",
    countdown: "倒计时",
    start: "开始",
    restart: "重新开始",
    pause: "暂停",
    resume: "继续",
    reset: "重置",
    markForExecution: "标记处决",
    clearMark: "清除标记",
    pleaseClaimSeat: "请先占座以进行投票。",
    secondsBetweenVotes: "秒间隔投票",
    // Vote History Modal
    clearVoteHistory: "清空投票历史",
    accessibleToPlayers: "玩家可见",
    clearForEveryone: "为所有人清空",
    time: "时间",
    type: "类型",
    voters: "投票者",
  },

  session: {
    liveSession: "在线会话",
    host: "主持",
    join: "加入",
    leave: "离开",
    sessionId: "会话ID",
    playerCount: "玩家数量",
    connecting: "连接中...",
    reconnecting: "重新连接中...",
    connected: "已连接",
    disconnected: "已断开",
    spectator: "观察者",
    claimSeat: "占座",
    distributeRoles: "发送角色",
    sendToPlayer: "发送给玩家",
    // Menu prompts and messages
    recentNomination: "条最近提名",
    recentNominations: "条最近提名",
    otherPlayersInSession: "位其他玩家在此会话中",
    msLatency: "毫秒延迟",
    enterChannelHost: "请输入房间号",
    enterPlayerCount: "请输入房间人数（5-20人）",
    invalidPlayerCount: "无效的玩家数量。请输入5到20之间的数字。",
    createRoom: "创建房间",
    enterRoomNumber: "请输入房间号",
    roomNumberPlaceholder: "例如：1196",
    playerCountPlaceholder: "5-20",
    errorEmptyRoomNumber: "房间号不能为空",
    enterChannelJoin: "输入房间号/链接",
    sessionIdPlaceholder: "房间号或链接",
    joinSession: "加入游戏",
    confirmDistributeRoles: "是否要将分配的角色发送给所有已就座的玩家？",
    confirmLeaveSession: "确定要离开当前进行中的游戏吗？",
    dissolveRoom: "解散房间",
    confirmDissolveRoom: "确定要解散房间吗？这将清空所有游戏数据。",
    joinDiscord: "加入 Discord",
    sourceCode: "源代码",
    storyteller: "说书人",
    storytellerAbility: "游戏主持人",
    // Send bluffs feature
    sendBluffs: "发送伪装身份",
    sendBluffsTo: "发送伪装身份给：",
    sendBluffsOptions: {
      demon: "发送给恶魔",
      lunatic: "发送给疯子",
      spy: "发送给间谍",
      bySeatNumber: "按座位号发送",
    },
    alsoSendBluffsToDemon: "是否同时给恶魔（疯子）发送伪装身份？",
    noDemonFound: "游戏中未找到恶魔",
    noLunaticFound: "游戏中未找到疯子",
    noSpyFound: "游戏中未找到间谍",
    enterSeatNumber: "请输入座位号：",
    seatNotOccupied: "此座位未被占用",
    invalidSeatNumber: "无效的座位号",
    bluffsReceived: "收到伪装身份",
    confirmSendBluffs: "确认发送伪装身份给以下玩家？",
    seat: "座位",
  },

  gameState: {
    export: "导出游戏状态",
    import: "导入游戏状态",
    copyToClipboard: "复制到剪贴板",
    pasteFromClipboard: "从剪贴板粘贴",
    downloadJSON: "下载 JSON",
    uploadJSON: "上传 JSON",
  },

  edition: {
    selectEdition: "选择剧本",
    troubleBrewing: "暗流涌动",
    badMoonRising: "月黯风高",
    sectsAndViolets: "异教紫罗兰",
    custom: "自定义剧本",
    uploadScript: "上传自定义剧本",
    level: {
      beginner: "新手",
      intermediate: "进阶",
      veteran: "老手",
    },
  },

  settings: {
    background: "背景图片",
    zoom: "缩放",
    muted: "静音",
    staticBackground: "静态背景",
    publicTownSquare: "公开城镇广场",
    nightMode: "夜间模式",
    imageOptIn: "显示自定义图片",
    language: "语言",
    toggleGrimoire: "切换魔典/城镇广场",
    nickname: "昵称",
    notSet: "未设置",
    enterNickname: "请输入你的昵称",
    clearStorage: "清空存储",
    confirmClearStorage:
      "确定要清空所有本地存储数据吗？这将清除所有设置、游戏数据和昵称，并刷新页面。",
    enterBackgroundUrl: "请输入背景图片URL",
    enterPlayerName: "请输入玩家名字",
    confirmImageOptIn: "确定要显示自定义角色图片吗？",
    confirmRandomizeSeating: "确定要随机打乱座位顺序吗？",
    confirmClearRoles: "确定要清空所有角色吗？",
  },

  modal: {
    reference: {
      title: "角色手册",
      jinx: "禁忌组合",
      selectAll: "全选",
    },
    nightOrder: {
      title: "夜间顺序",
      firstNight: "首夜",
      otherNights: "其他夜晚",
    },
    reminder: {
      title: "添加提示标记",
      customReminder: "自定义提示",
      addCustom: "添加自定义提示",
    },
    role: {
      title: "选择角色",
      search: "搜索角色...",
    },
  },

  messages: {
    confirmRemovePlayer: "确认移除此玩家？",
    confirmClearPlayers: "确认清空所有玩家？",
    confirmClearRoles: "确认清空所有角色？",
    missingRoles: "缺失角色：{roles}",
    sessionError: "会话连接错误",
    invalidGameState: "无效的游戏状态数据",
    copiedToClipboard: "已复制到剪贴板！",
  },

  intro: {
    welcome: "欢迎来到染钟镇",
    description: "一个非官方的在线工具，用于运行染钟镇游戏",
    start: "开始游戏",
    hostGame: "创建游戏",
    joinGame: "加入游戏",
    // Intro page
    welcomeToUnofficial: "欢迎来到（非官方的）",
    virtualTownSquare: "虚拟城镇广场与魔典",
    forBloodOnClockTower: "染钟镇游戏！",
    pleaseAddPlayers: "请通过右上角的",
    onTopRight: "添加更多玩家，或按",
    canAlsoJoin: "。你也可以按此键加入游戏会话",
    projectOpenSource: "本项目是免费开源的，可以在此找到",
    github: "GitHub",
    notAffiliated:
      '。本项目不隶属于 The Pandemonium Institute。"Blood on the Clocktower" 是 Steven Medway 和 The Pandemonium Institute 的商标。',
  },

  townInfo: {
    pleaseAddMorePlayers: "请添加更多玩家！",
    by: "作者",
    nightPhase: "夜间阶段",
  },

  townSquare: {
    otherCharacters: "不在场角色",
    demonBluffs: "恶魔的伪装身份",
    fabled: "传奇角色",
    firstNight: "首夜",
    otherNights: "其他夜晚",
    removePlayer: "移除玩家",
    confirmRemovePlayer: "确定要移除",
  },

  chat: {
    privateChatTitle: "私聊",
    privateChatWith: "与",
    noMessages: "暂无消息",
    typeMessage: "输入消息...",
    send: "发送",
    chatWithStoryteller: "与说书人私聊",
    cancel: "取消",
    screenshotTimer: "定时（阅后即焚）",
    screenshotRevoke: "手动撤回",
    screenshotTTL: "时长：",
    screenshotSeconds: "秒",
    screenshotSecondsLeft: "秒剩余",
    sendScreenshot: "发送截图",
    screenshotExpired: "截图已过期",
    screenshotLabel: "魔典截图",
    screenshotView: "查看",
    screenshotViewAgain: "再次查看",
    screenshotViewTime: "你有 {seconds} 秒查看时间",
    screenshotRevokeBtn: "撤回",
    screenshotTapToClose: "点击任意位置关闭",
  },

  modals: {
    edition: {
      selectEdition: "选择一个版本：",
      loadCustomScript: "加载自定义剧本 / 角色",
      popularScripts: "一些热门的自定义剧本：",
      customScriptCharacters: "自定义剧本 / 角色",
      uploadJSON: "上传 JSON",
      enterURL: "输入 URL",
      useClipboard: "使用剪贴板中的 JSON",
      customScriptInstructions: "要使用自定义剧本，你需要在官方的",
      scriptTool: "剧本工具",
      andUpload:
        '中选择你想要游玩的角色，然后上传生成的 "custom-list.json" 文件，或提供一个托管该 JSON 文件的 URL。',
      customCharacterInstructions: "要使用自定义角色，请阅读",
      theDocumentation: "文档",
      onHowToWrite: "了解如何编写自定义角色定义文件。",
      warningTrustSource: "只加载你信任来源的自定义 JSON 文件！",
      errorReading: "读取自定义剧本时出错：",
      enterURLPrompt: "输入 custom-script.json 文件的 URL",
      errorLoading: "加载自定义剧本时出错：",
      pasteScriptPrompt: "HTTP 模式下无法使用剪贴板 API。请在此处粘贴你的剧本 JSON：",
      pasteScriptTitle: "粘贴剧本 JSON",
      pasteScriptPlaceholder: "在此处粘贴你的剧本 JSON...",
    },
    roles: {
      selectCharacters: "为 {count} 位玩家选择角色：",
      warningSetupRoles:
        "警告：已选择的角色会修改游戏设置！随机分配器不会考虑这些角色。",
      allowDuplicates: "允许重复角色",
      assignRandomly: "随机分配 {count} 个角色",
      shuffleCharacters: "重新随机选择角色",
    },
    reference: {
      showNightOrder: "显示夜间顺序",
      characterReference: "角色手册",
      customScript: "自定义剧本",
      jinxed: "禁忌组合",
    },
    gameState: {
      currentGameState: "当前游戏状态",
      copyJSON: "复制 JSON",
      loadState: "加载状态",
      unableToParse: "无法解析 JSON：",
    },
    nightOrder: {
      showCharacterReference: "显示角色手册",
      nightOrder: "夜间顺序",
      customScript: "自定义剧本",
      firstNight: "首夜",
      otherNights: "其他夜晚",
      minionInfo: "爪牙信息",
      demonInfo: "恶魔信息与不在场角色",
      minionReminder1: "• 如果有多个爪牙，他们都要互相进行眼神接触。",
      minionReminder2: "• 展示「这是恶魔」卡片。指向恶魔。",
      demonReminder1: "• 展示「这些是你的爪牙」卡片。指向每个爪牙。",
      demonReminder2:
        "• 展示「这些角色不在游戏中」卡片。展示 3 个不在游戏中的善良角色标记。",
      cardThisIsDemon: "这是恶魔",
      cardTheseAreMinions: "这些是你的爪牙",
      cardNotInPlay: "这些角色不在游戏中",
    },
    reminder: {
      chooseReminder: "选择一个提示标记：",
      good: "善良",
      evil: "邪恶",
      customNote: "自定义备注",
      addCustomReminder: "添加自定义提示备注",
    },
    role: {
      chooseCharacterFor: "为以下玩家选择新角色",
      bluffing: "不在场角色",
      editionRoles: "版本角色",
      otherTravelers: "其他旅行者",
      showAllRoles: "显示全部角色（包括在场角色）",
    },
    fabled: {
      chooseFabled: "选择一个传奇角色加入游戏",
    },
  },
};
